import React, { useEffect, useMemo, useState } from "react";
import { Formik, Form, Field } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useMerchantUIContext } from "../MerchantUIContext";
import { fetchSingleBcMerchant, fetchSingleWixMerchant, fetchSingleWpMerchant } from "../../../actions/merchants/merchants";
import { useSnackbar } from "notistack";
import { Input } from "../../../_metronic/_partials/controls";

export function MerchantView({ history, match }) {

  const type = match.params.type
  const id = match.params.id

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tabvalue = params.get('tab');

  const onHide = () => {
    history.push(`/merchants?tab=${tabvalue}`);
  }

  const dispatch = useDispatch();

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    if (type === 'wix') {

      await dispatch(fetchSingleWixMerchant(id));

    } else if (type === 'wp') {

      await dispatch(fetchSingleWpMerchant(id));

    } else if (type === 'bc') {

      await dispatch(fetchSingleBcMerchant(id));

    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, type]);

  const { enqueueSnackbar } = useSnackbar();

  const { wixmerchantForEdit, wpmerchantForEdit, bcmerchantForEdit } = useSelector(
    (state) => ({
      wixmerchantForEdit: id ? state.merchants.wixmerchantForEdit?.docs : undefined,
      wpmerchantForEdit: id ? state.merchants.wpmerchantForEdit?.data : undefined,
      bcmerchantForEdit: id ? state.merchants.bcmerchantForEdit?.docs : undefined,
    }),
    shallowEqual
  );

  let initialValue = {}
  if (type === "wix") {
    initialValue = {
      url: wixmerchantForEdit?.shop,
      email: wixmerchantForEdit?.state,
      email2: wixmerchantForEdit?.extra_email
    }
  } else if (type === 'wp') {
    initialValue = {
      url: wpmerchantForEdit?.store_url,
      email: wpmerchantForEdit?.user_email,
      email2: wpmerchantForEdit?.user_email2,
    }
  } else if (type === 'bc') {
    initialValue = {
      url: bcmerchantForEdit?.shop,
      email: bcmerchantForEdit?.user_email,
      email2: bcmerchantForEdit?.extra_email,
    }
  }

  return (
    <div className='form form-label-right p-5'>
      <div className='form-group row mt-5 pl-5'>
        <p class="h5">
          {type === "wix" ? "Wix" : type === "wp" ? "Wordpress" : "Bigcommerce"} Merchant View
        </p>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
      >
        <Form className='form form-label-right'>
          <>
            <div className='form-group row mt-5'>
              <Field
                name="url"
                component={Input}
                placeholder='Store URL'
                label="Store URL"
                disabled
              />
            </div>
            <div className='form-group row mt-5'>
              <Field
                name="email"
                component={Input}
                placeholder='User email'
                label="User Email"
                disabled
              />
            </div>
            <div className='form-group row mt-5'>
              <Field
                name="email2"
                component={Input}
                placeholder='User email 2'
                label="User Secondary Email"
                disabled
              />
            </div>

          </>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
        </Form>
      </Formik>
    </div>
  );
}
